import React from 'react';

import { appNamedRoutes } from 'routes';

import PageSubNav from 'components/nav/PageSubNav';

const ADMINISTRATION_PAGES = [
  {
    path: appNamedRoutes.administrationStaff,
    label: 'Your Staff',
  },
  {
    path: appNamedRoutes.administrationOrganization,
    label: 'Your Organization',
  },
  {
    path: appNamedRoutes.administrationFamilies,
    label: 'Your Families',
  },
];


const AdministrationSubNav = () => {
  return (
    <PageSubNav items={ADMINISTRATION_PAGES} />
  );
};

export default AdministrationSubNav;
